<template>
  <Panel class="p-0 " header="Processo seletivo em andamento">
    <div v-if="!processo.nome" class="field col-12 md:col-6 ">
      <p>No momento, não existe processo seletivo em andamento.</p>
      <router-link :to="{ name: 'processos.seletivos' }">
        <Button label="Cadastrar novo processo" type="submit"></Button>
      </router-link>
    </div>

    <div v-if="processo.nome" class="surface-section m-0 p-0">
      <ul class="list-none p-0 m-4">
        <li
          class="flex align-items-stretch   flex-wrap surface-border py-2 px-2"
        >
          <div
            class="text-500 w-12 md:w-2 font-bold font-medium text-right mr-4"
          >
            Processo seletivo:
          </div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            {{ processo.nome }}
          </div>
        </li>
        <li class="flex align-items-center py-2 px-2  surface-border flex-wrap">
          <div
            class="text-500 w-12 md:w-2  font-bold font-medium text-right mr-4"
          >
            Descrição:
          </div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            {{ processo.descricao }}
          </div>
        </li>
        <li class="flex align-items-center py-2 px-2  surface-border flex-wrap">
          <div
            class="text-500 w-6 md:w-2  font-bold font-medium text-right mr-4"
          >
            Período de inscrição:
          </div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            <label id="periodoINICIO" class="font-bold  ">{{
              processo.datHoraInicioInscricao.substring(0, 10)
            }}</label>
            <label>{{ processo.datHoraInicioInscricao.substring(10) }}</label>
            <span class="font-bold m-2" for="periodo"> Até </span>
            <label id="periodoFIM" class="font-bold m-2">{{
              processo.datHoraFimInscricao.substring(0, 10)
            }}</label>
            <label>{{ processo.datHoraFimInscricao.substring(10) }}</label>
            <span v-if="processo.inscricaoEncerrada" class="p-error font-bold ml-4  m-2">
                Inscrições encerradas!
            </span>
          </div>
        </li>
        <!-- <li class="flex align-items-center py-2 px-2  surface-border flex-wrap" v-if="!processo.analiseDocumental">
          <div class="text-500 w-12 md:w-2  font-bold font-medium text-right mr-4">
            Data provável da prova:
          </div>
          <div class=" text-900 w-full md:w-8 md:flex-order-0 flex-order-1"> {{ processo.prova ? $formatarData(processo.prova.dataHoraInicioProva) : '' }} </div>
        </li> -->
        <li class="flex align-items-center py-2 px-2  surface-border flex-wrap" v-if="processo.tipoSelecao.estagio">
          <div class="text-500 w-12 md:w-2  font-bold font-medium text-right mr-4">
            Coeficiente escolar mínimo:
          </div>
          <div class=" text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            {{ processo.coeficienteMinimo }}
          </div>
        </li>
      </ul>


    </div>


  </Panel>
</template>

<script>
import moment from "moment";

export default {
  components: {},
  props: ["processo"],

  data() {
    return {
      habilitaInscricoes: false,
    };
  },

  inscricaoService: null,
  estadoInscricaoService: null,

  created() {},

  async mounted() {},

  methods: {
    inscricoesEmAberto(data_fim_inscricao) {
      //Formato esperado YYYY-MM-DD
      //2022-01-31T23:59:59

      var fimInscricaoDate = moment(
        data_fim_inscricao,
        "DD-MM-YYYY HH:mm:ss"
      ).format("MM/DD/YYYY  HH:mm:ss");
      fimInscricaoDate = new Date(fimInscricaoDate);
      const dataAtual = new Date();

      if (fimInscricaoDate.getTime() > dataAtual.getTime()) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.aguarde {
  width: 130px;
  height: 130px;
  text-align: center;
}

* {
  box-sizing: border-box;
}

/* Set a background color */
body {
  background-color: #474e5d;
  font-family: Helvetica, sans-serif;
}

/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: "";
  position: absolute;
  width: 6px;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.container {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.container::after {
  content: "";
  position: absolute;
  width: 25px;
  height: 25px;
  right: -17px;
  background-color: white;
  border: 4px solid #ff9f55;
  top: 15px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.left {
  left: 0;
}

/* Place the container to the right */
.right {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.left::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.right::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.right::after {
  left: -16px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
  /* Place the timelime to the left */
  .timeline::after {
    left: 31px;
  }

  /* Full-width containers */
  .container {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

  /* Make sure that all arrows are pointing leftwards */
  .container::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

  /* Make sure all circles are at the same spot */
  .left::after,
  .right::after {
    left: 15px;
  }

  /* Make all right containers behave like the left ones */
  .right {
    left: 0%;
  }
}
</style>
